import { Delete } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

const Jobpreference = ({ userId }) => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [preferences, setPreferences] = useState({
    jobTitle: "",
    location: "",
    userId: userId,
    expeirence: "",
    areaOfWork: "",
    dreamCompanies: "", // Comma-separated string
    notToApplyCompanies: "", // Comma-separated string
  });

  const [dreamCompaniesArray, setDreamCompaniesArray] = useState([]);
  const [notToApplyCompaniesArray, setNotToApplyCompaniesArray] = useState([]);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [newDreamCompany, setNewDreamCompany] = useState("");
  const [newNotToApplyCompany, setNewNotToapplyCompany] = useState("");

  useEffect(() => {
    fetchPreferences();
  }, [userId]);

  const fetchPreferences = async () => {
    try {
      const response = await axios.get(
        `${BASE_API_URL}/getPreferencesByUserId`,
        {
          params: { userId: userId },
        }
      );

      if (response.status === 200 && response.data) {
        setPreferences(response.data);
        setDreamCompaniesArray(
          response.data.dreamCompanies.split(",").filter(Boolean)
        );
        setNotToApplyCompaniesArray(
          response.data.notToApplyCompanies.split(",").filter(Boolean)
        );
        setIsFormDisabled(
          response.data.jobTitle ||
            response.data.location ||
            response.data.expeirence
            ? true
            : false
        );
      }
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPreferences({
      ...preferences,
      [name]: value,
    });
  };

  const handleAddCompany = (type) => {
    if (
      type === "dreamCompanies" &&
      newDreamCompany &&
      !dreamCompaniesArray.includes(newDreamCompany)
    ) {
      setDreamCompaniesArray([...dreamCompaniesArray, newDreamCompany]);
      setNewDreamCompany("");
    } else if (
      type === "notToApplyCompanies" &&
      newNotToApplyCompany &&
      !notToApplyCompaniesArray.includes(newNotToApplyCompany)
    ) {
      setNotToApplyCompaniesArray([
        ...notToApplyCompaniesArray,
        newNotToApplyCompany,
      ]);
      setNewNotToapplyCompany("");
    }
  };

  const handleRemoveCompany = (type, index) => {
    if (type === "dreamCompanies") {
      const updatedArray = [...dreamCompaniesArray];
      updatedArray.splice(index, 1);
      setDreamCompaniesArray(updatedArray);
    } else if (type === "notToApplyCompanies") {
      const updatedArray = [...notToApplyCompaniesArray];
      updatedArray.splice(index, 1);
      setNotToApplyCompaniesArray(updatedArray);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !preferences.jobTitle &&
      !preferences.location &&
      !preferences.expeirence
    ) {
      toast.error("Please fill in at least one field before submitting.");
      return;
    }

    const dreamCompaniesStr = dreamCompaniesArray.join(",");
    const notToApplyCompaniesStr = notToApplyCompaniesArray.join(",");

    try {
      let response;

      // 👉 IF preference already exists → UPDATE
      if (preferences.jobPreferenceId) {
        response = await axios.put(
          `${BASE_API_URL}/updatePreferences`,
          {
            ...preferences,
            dreamCompanies: dreamCompaniesStr,
            notToApplyCompanies: notToApplyCompaniesStr,
          },
          {
            params: { jobPreferenceId: preferences.jobPreferenceId },
            headers: { "Content-Type": "application/json" },
          }
        );
      }
      // 👉 ELSE → CREATE
      else {
        response = await axios.post(
          `${BASE_API_URL}/jobPreferences`,
          {
            ...preferences,
            dreamCompanies: dreamCompaniesStr,
            notToApplyCompanies: notToApplyCompaniesStr,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      if (response.status === 200) {
        setIsFormDisabled(true);

        await Swal.fire({
          title: "Success!",
          text: "Your job preferences are successfully saved.",
          icon: "success",
          confirmButtonText: "OK",
        });

        fetchPreferences();
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error submitting preferences!");
    }
  };

  const handleEdit = () => {
    setIsFormDisabled(false);
  };

  return (
    <>
      <h4>Job preference:</h4>
      <p className="">
        <strong>Note : </strong>Set your ideal job preferences here, and let AI suggest matching jobs in
        the Jobs section.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <div className="col-sm-6">
            <label htmlFor="areaOfWork" className="form-label">
              Area of work
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="areaOfWork"
              name="areaOfWork"
              value={preferences.areaOfWork}
              onChange={handleChange}
              placeholder="Enter Area of work Eg:Workday, naukri , indeed etc"
              disabled={isFormDisabled}
            />
          </div>
          <div className="col-sm-6">
            <label htmlFor="jobTitle" className="form-label">
              Job Title
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="jobTitle"
              name="jobTitle"
              value={preferences.jobTitle}
              onChange={handleChange}
              placeholder="Enter Job Title"
              disabled={isFormDisabled}
            />
          </div>
        </div>
        <div className="mb-3 row">
          <div className="col-sm-6">
            <label htmlFor="expeirence" className="form-label">
              Experience
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="expeirence"
              name="expeirence"
              value={preferences.expeirence}
              onChange={handleChange}
              placeholder="Enter experience Eg:3 years "
              disabled={isFormDisabled}
            />
          </div>
          <div className="col-sm-6">
            <label htmlFor="location" className="form-label">
              Location
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="location"
              name="location"
              value={preferences.location}
              onChange={handleChange}
              placeholder="Enter Location"
              disabled={isFormDisabled}
            />
          </div>
        </div>

        <div className="mb-3 row">
          <div className="col-sm-6">
            <label htmlFor="dreamCompanies" className="form-label">
              Dream Companies
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-sm"
                id="dreamCompanies"
                name="dreamCompanies"
                value={newDreamCompany}
                onChange={(e) => setNewDreamCompany(e.target.value)}
                placeholder="Enter dream companies"
                disabled={isFormDisabled}
              />
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handleAddCompany("dreamCompanies")}
                disabled={isFormDisabled}
              >
                Add
              </button>
            </div>
            <div className="mt-2">
              {dreamCompaniesArray.length > 0 && (
                <div>
                  <div>Companies Added: </div>
                  <div className="d-flex flex-wrap">
                    {dreamCompaniesArray.map((company, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center me-3 mb-2"
                      >
                        <span className="me-2">
                          {company}
                          <i
                            className="fas fa-times text-danger ms-2"
                            onClick={() =>
                              handleRemoveCompany("dreamCompanies", index)
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "1rem",
                            }}
                          >
                            <Delete />
                          </i>
                        </span>
                        {index < dreamCompaniesArray.length - 1 && (
                          <span>, </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-sm-6">
            <label htmlFor="notToApplyCompanies" className="form-label">
              Not To Apply Companies
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-sm"
                id="notToApplyCompanies"
                name="notToApplyCompanies"
                value={newNotToApplyCompany}
                onChange={(e) => setNewNotToapplyCompany(e.target.value)}
                placeholder="Enter companies to avoid"
                disabled={isFormDisabled}
              />
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handleAddCompany("notToApplyCompanies")}
                disabled={isFormDisabled}
              >
                Add
              </button>
            </div>
            <div className="mt-2">
              {notToApplyCompaniesArray.length > 0 && (
                <div>
                  <div>Companies Added: </div>
                  <div className="d-flex flex-wrap">
                    {notToApplyCompaniesArray.map((company, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center me-3 mb-2"
                      >
                        <span className="me-2">
                          {company}
                          <i
                            className="fas fa-times text-danger ms-2"
                            onClick={() =>
                              handleRemoveCompany("notToApplyCompanies", index)
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "1rem",
                            }}
                          >
                            <Delete />
                          </i>
                        </span>
                        {index < notToApplyCompaniesArray.length - 1 && (
                          <span>,</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <p>
          <strong>Example:</strong> Preferences you can add for AI job matching
          Jobs like Job Title, Location.
        </p>
        <ul>
          <li>
            <strong>Area of Work:</strong> e.g., Workday, Naukri, Indeed, Job
            Portals
          </li>
          <li>
            <strong>Job Title:</strong> e.g., Software Developer, Backend
            Developer
          </li>
          <li>
            <strong>Experience:</strong> e.g., 3 years, 5+ years, Fresher
          </li>
          <li>
            <strong>Location:</strong> e.g., Bangalore, Hyderabad, USA
          </li>
        </ul>

        <Button type="submit" disabled={isFormDisabled}>
          Save
        </Button>
        <Button
          type="button"
          variant="info"
          onClick={handleEdit}
          disabled={!isFormDisabled}
          className="ms-2"
        >
          Edit
        </Button>
      </form>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      />
    </>
  );
};

export default Jobpreference;
